import styled from 'particles/themes/styled'

interface NumberInputContainerProps {
    isDisabled: boolean
    hasError: boolean
    height: string
    padding: string
    width?: string
}

export const NumberInputContainer = styled.div<NumberInputContainerProps>`
    border: 1px solid;
    border-color: ${({ theme, hasError, isDisabled }) =>
        !isDisabled && hasError ? theme.colors.border.error : theme.colors.border.primary};
    height: ${({ height }) => height};
    align-items: center;
    width: ${({ width }) => width || '224px'};
    border-radius: 4px;
    padding: ${({ padding }) => `0px ${padding}`};
    box-sizing: border-box;
    display: flex;
    gap: ${({ theme }) => theme.spacing[100]};
    background: ${({ theme, isDisabled }) =>
        isDisabled ? theme.colors.surface.disablePastel : theme.colors.surface.primary};

    &:has(.number-input:focus) {
        border-color: ${({ theme }) => theme.colors.border.neutralActionActive};
    }

    input[type='number'] {
        border: none;
        outline: none;
        flex: 1;
        min-width: 0px;

        &:disabled {
            color: ${({ theme }) => theme.colors.text.disable};
        }

        &:disabled::placeholder {
            color: ${({ theme }) => theme.colors.text.disable};
        }
    }

    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
    }
`

interface WrapperProps {
    gap: string
}
export const Wrapper = styled.div<WrapperProps>`
    display: flex;
    flex-direction: column;
    gap: ${({ gap }) => gap};
    width: 100%;
    font-family: inherit;

    input[type='number'] {
        font-family: inherit;
    }
`
interface ReadOnlyContainerProp {
    width?: string
    height: string
    hasValue: boolean
    padding: string
}

export const ReadOnlyContainer = styled.div<ReadOnlyContainerProp>`
    width: ${({ width }): string => (width ? width : '224px')};
    min-height: ${({ height }) => height};
    padding: ${({ padding }) => padding};
    display: flex;
    align-items: center;
    border-radius: 4px;
    box-sizing: border-box;
    border: none;
    border-left: 1px solid ${({ theme }) => theme.colors.border.primary};
    color: ${({ hasValue, theme }) => (hasValue ? theme.colors.text.primary : theme.colors.text.tertiary)};
    outline: none;
    font-family: inherit;
`
